<template>
    <div class="aba-cliente">
        <container-loader v-if="isLoading && !$store.getters.isLoading" />
        <div class="vertical-flow">
            <div class="columns">
                <!-- CAIXA DE BUSCA -->
                <div
                    class="column"
                    :class="[
                        permissaoVincular && permissaoCadastrar
                            ? 'is-4'
                            : permissaoVincular || permissaoCadastrar
                            ? 'is-6'
                            : 'is-8',
                    ]"
                >
                    <search-bar
                        :onSearch="debouncedOnSearch"
                        tooltipLabel="msg-campo-busca-tipo-pedido"
                    />
                </div>

                <!-- SELEÇÃO DE SITUAÇÃO -->
                <div
                    class="column"
                    :class="[
                        permissaoVincular && permissaoCadastrar
                            ? 'is-2'
                            : permissaoVincular || permissaoCadastrar
                            ? 'is-3'
                            : 'is-4',
                    ]"
                >
                    <vss-select
                        ref="situacaoSelect"
                        :searchable="false"
                        :options="situacaoSelect"
                        v-model="situacaoSelected"
                        mlLabels
                        title="situacao"
                        clearable
                        @input="onSituacaoChanged"
                        :height="40"
                    />
                </div>

                <!-- BOTÃO DE VÍNCULO -->
                <div class="column is-3" v-if="permissaoVincular">
                    <button
                        class="save-btn botao-acao"
                        type="button"
                        @click="showModalTipoPedidoNaoAssociados"
                    >
                        {{ $t('vincular') }} {{ $t('tipo-pedido') }}
                    </button>
                </div>

                <div class="column is-3" v-if="permissaoCadastrar">
                    <button
                        class="save-btn botao-acao"
                        type="button"
                        @click="
                            $router.push({
                                name: isVenda ? 'ven-tipopedido-new' : 'agro-tipopedido-new',
                                query: {
                                    tela: 'cliente-tipo-pedido',
                                    id: $route.params.id,
                                    dadoscadastrais: $route.query.dadoscadastrais
                                        ? $route.query.dadoscadastrais
                                        : null,
                                    politicacomercial: 6,
                                    analisecomercial: $route.query.analisecomercial
                                        ? $route.query.analisecomercial
                                        : null,
                                    contexto: isVenda ? 'ven' : 'agro',
                                },
                            })
                        "
                    >
                        {{ $t('adicionar') }} {{ $t('tipo-pedido') }}
                    </button>
                </div>
            </div>

            <!-- LISTAGEM -->
            <div class="registry-wrapper">
                <empty-table-message v-if="isEmpty" />
                <b-table
                    v-else
                    :data="asstipopedidocliente"
                    class="data-table"
                    @sort="sortTable"
                    backend-sorting
                >
                    <b-table-column
                        v-for="(f, i) in fields"
                        :key="i"
                        :field="f.key"
                        :label="f.key != 'excluir' ? $t(f.key) : ''"
                        :width="f.width"
                        :class="{
                            'excluir-field': f.key == 'excluir',
                        }"
                        :sortable="f.sortable"
                        :custom-sort="f.sortFn"
                        v-slot="props"
                    >
                        <!-- COLUNA DE DESATIVAÇÃO/REATIVAÇÃO -->
                        <div v-if="f.key == 'excluir'">
                            <b-button
                                v-if="permissao.update && !assTipoPedidoClienteIntegracao"
                                class="action-button"
                                :type="
                                    props.row['replicapda'] == 3
                                        ? 'is-danger'
                                        : 'is-success'
                                "
                                :icon-right="
                                    props.row['replicapda'] == 3 ? 'delete' : 'check'
                                "
                                @click="promptChangeSituacao(props.row)"
                                v-tippy 
                                :title="$t(props.row['replicapda'] == 3 ? 'desativar' : 'reativar')"
                            />
                        </div>

                        <!-- COLUNA DE SITUAÇÃO -->
                        <div v-else-if="f.key == 'replicapda'">
                            <b-tag
                                class="table-tag table-tag-full-width"
                                :type="props.row['replicapda'] == 3 ? 'is-success' : 'is-danger'"
                                size="is-medium"
                            >
                                {{ $t(props.row['replicapda'] == 3 ? 'ativo' : 'inativo') }}
                            </b-tag>
                        </div>
                        <div v-else>
                            {{ props.row[f.key] }}
                        </div>
                    </b-table-column>
                </b-table>

                <!-- PAGINAÇÃO -->
                <PaginationViewer
                    class="mb-0"
                    :resetPagination="pagination.resetPagination"
                    :totalItems="pagination.totalRows"
                    :perPageOptions="pagination.perPageOptions"
                    :optionStarted="pagination.optionStarted"
                    @change="updatePagination"
                />
            </div>

            <!-- MODAL DE ASSOCIACAO -->
            <b-modal :active.sync="showModalAssociacao">
                <div class="bg">
                    <TipoPedidoModal :idCliente="$route.params.id" @fecharModal="fecharModal" />
                </div>
            </b-modal>
        </div>
    </div>
</template>

<script>
// SERVICES
import AssTipoPedidoClienteService from '@/services/vendas/cliente/abas/AssTipoPedidoClienteService';
import TipoPedidoModal from '@/components/vendas/cliente/modal/TipoPedidoModal.vue';

// COMPONENTS
import ContainerLoader from '@/components/content/loader/ContainerLoader';

export default {
    components: {
        ContainerLoader,
        TipoPedidoModal,
    },
    data() {
        return {
            assTipoPedidoClienteIntegracao: this.$store.state.user.tabelasERPWebServer.includes(
                'ASSTIPOPEDIDOCLIENTE'
            ),
            tipoPedidoIntegracao: this.$store.state.user.tabelasERPWebServer.includes('TIPOPEDIDO'),
            asstipopedidocliente: [],
            fields: [
                { key: 'codigo', width: 80, sortable: true, sortFn: null },
                { key: 'tipo-pedido', width: null, sortable: true, sortFn: null },
                { key: 'replicapda', width: 80, sortable: true, sortFn: null },
                { key: 'excluir', width: 20, sortable: false, sortFn: null },
            ],
            service: new AssTipoPedidoClienteService(this.$http, this.$router),
            permissao: false,
            permissaoUsuario: false,
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            situacaoSelected: { id: 4, label: 'todos' },
            situacaoSelect: [
                { id: 4, label: 'todos' },
                { id: 3, label: 'ativos' },
                { id: 2, label: 'inativos' },
            ],
            isLoading: false,
            isEmpty: false,
            debouncedOnSearch: null,
            queryFilter: '',
            column: 'tipo-pedido',
            order: 'asc',
            isSaving: false,
            delete: null,
            showModalAssociacao: false,

            //permissoes relativas à exibição dos botões
            permissaoVincular: false,

            // @86308 - Rota dinâmica abreviando o contexto
            isVenda: this.$route.meta.contexto == 'vendas',
            isAgro: this.$route.meta.contexto == 'agro',
        };
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];

        if (this.isVenda) {
            this.permissao = this.hasPermissionAccess(
                'vendas',
                'clientes',
                'ven-cliente-politica-comercial-tipo-pedido'
            );
            this.tipoPedidoPermissao = this.hasPermissionAccess(
                'vendas',
                'clientes',
                'ven-tipopedido'
            );
        } else if (this.isAgro) {
            this.permissao = this.hasPermissionAccess(
                'agro',
                'clientes',
                'agro-cliente-politica-comercial-tipo-pedido'
            );
            this.tipoPedidoPermissao = this.hasPermissionAccess(
                'agro',
                'clientes',
                'agro-tipopedido'
            );
        }

        // variáveL que define as permissões com base nas permissões da tela e dos dados que vêm do ERP
        this.permissaoVincular = this.permissao.create && !this.assTipoPedidoClienteIntegracao;
        this.permissaoCadastrar = this.tipoPedidoPermissao.create && !this.tipoPedidoIntegracao;

        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'cliente' },
            });
        } else {
            this.carregarDados();
            this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        }
    },
    methods: {
        generateId(numberId) {
            return this.$route.name + '-tipo-pedido-' + numberId;
        },
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;

            this.isLoading = true;

            this.findAll(
                this.column,
                this.order,
                currentPage - 1,
                this.pagination.perPage,
                this.situacaoSelected.id,
                this.$route.params.id,
                this.queryFilter
            )
                .then(this.mapItems)
                .then((value) => {
                    this.asstipopedidocliente = value;
                    this.isEmpty = this.asstipopedidocliente.length <= 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar tabela de tipos de pedido.');
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        findAll(column, order, page, limit, situacao, idcliente, ...params) {
            if (this.isVenda) {
                return this.service.findAllVendas(
                    column,
                    order,
                    page,
                    limit,
                    situacao,
                    idcliente,
                    ...params
                );
            } else {
                return this.service.findAllAgro(
                    column,
                    order,
                    page,
                    limit,
                    situacao,
                    idcliente,
                    ...params
                );
            }
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;

            return body.content.map((m) => {
                return {
                    idasstipopedidocliente: m.idasstipopedidocliente,
                    codigo: m.idtipopedido,
                    'tipo-pedido': m.tipopedido.descricao,
                    replicapda: m.replicapda,
                };
            });
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados(this.pagination.currentPage);
        },
        onSituacaoChanged(val) {
            this.situacaoSelected = val
                ? this.situacaoSelect.filter((v) => v.id == val.id)[0]
                : this.situacaoSelect[0];
            this.carregarDados();
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        promptChangeSituacao(row) {
            this.delete = row;
            let message = this.$t(
                    row.replicapda == 3
                        ? 'msg-confirmacao-desativacao-n'
                        : 'msg-confirmacao-reativacao-n', 
                    { n: row['tipo-pedido'] }
                );
            this.$root.confirm({
                message: message,
                onConfirm: this.updateSituacaoRegistro,
                onCancel: this.removePrompt,
            });
        },
        removePrompt() {
            this.delete = null;
        },
        updateSituacaoRegistro() {
            let tempFailure =
                this.delete.replicapda == 3
                    ? 'msg-erro-ao-desativar-associacao-tipo-pedido'
                    : 'msg-erro-ao-reativar-associacao-tipo-pedido';

            let tempAssTipoPedidocliente = {
                idasstipopedidocliente: this.delete.idasstipopedidocliente,
                replicapda: this.delete.replicapda == 3 ? 2 : 3,
            };

            this.isLoading = true;

            this.updateSituacao(tempAssTipoPedidocliente)
                .then((r) => {
                    if (r.status == 200) {
                        let tempSuccess =
                            r.content.replicapda == 3
                                ? 'msg-sucesso-ao-reativar-associacao-tipo-pedido'
                                : 'msg-sucesso-ao-desativar-associacao-tipo-pedido';
                        this.$root.showMessage('success', tempSuccess);
                        this.carregarDados(this.pagination.currentPage);
                    } else if (r.status == 500) {
                        this.$root.showMessage('error', 'Erro ao atualizar status.');
                    }
                })
                .catch((e) => {
                    console.error('Erro ao atualizar status.', e);
                    this.$root.showMessage('error', tempFailure);
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.delete = null;
                });
        },
        updateSituacao(assTipoPedidocliente) {
            if (this.isVenda) return this.service.updateSituacaoVendas(assTipoPedidocliente);
            else return this.service.updateSituacaoAgro(assTipoPedidocliente);
        },
        redirect(name) {
            setTimeout(() => {
                this.$router.push(
                    {
                        name: name,
                        query: {
                            tela: 'cliente-usuario',
                            'id-cliente': this.$route.params.id,
                        },
                    },
                    1000
                );
            });
        },
        showModalTipoPedidoNaoAssociados() {
            this.showModalAssociacao = !this.showModalAssociacao;
        },
        fecharModal() {
            this.showModalAssociacao = false;
            this.carregarDados();
        },
        closeModalCadastro() {
            this.showModalCadastroForma = false;
        },
    },
};
</script>

<style lang="scss" scoped>
.aba-cliente {
    height: 100%;

    .botao-acao {
        margin-top: 24px;
        width: 100%;
        height: 40px;
    }

    @media (max-width: 760px) {
        .search-bar {
            padding-bottom: 0.4rem;
        }
        .botao-acao {
            margin-top: 0;
        }
    }
}
</style>
